module.exports = __webpack_public_path__ + "static/media/cassensPlath.40abe7c4.png";